import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkloadManagedTeamEntity } from '../../../domain/entities/workload-managed-team.entity';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { GetMemberManagedTeamsQuery } from './get-member-managed-teams.query';

@Injectable({ providedIn: 'root' })
export class GetMemberManagedTeamsUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(query: GetMemberManagedTeamsQuery): Observable<WorkloadManagedTeamEntity[]> {
    return this._repository.getMemberManagedTeams(query.userId);
  }
}
